import { Get, Post, url } from "api";
import {
  ConversationResponse,
  FileUploadResponse,
} from "views/admin/chatbot/chatbot";

const BASE_PATH = "/manage/chatbot";

export const createConversation = async (): Promise<ConversationResponse> => {
  try {
    const response = await Post(`${BASE_PATH}/conversations`, {});
    return response;
  } catch (error) {
    console.error("Error creating conversation:", error);
    throw error;
  }
};

export const uploadContextFile = async (
  file: File
): Promise<FileUploadResponse> => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const token = localStorage.getItem("jwtToken");
    const uploadUrl = `${url}${BASE_PATH}/context-files`;

    const response = await fetch(uploadUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: formData,
    });

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const result = await response.json().catch((e) => {
        console.warn("JSON parse error:", e);
        throw e;
      });

      return result;
    }

    return {
      fileId: "unknown",
      filename: file.name,
      status: "uploaded",
    };
  } catch (error) {
    console.error("💥 Error uploading context file:", error);
    throw error;
  }
};

export const createChatStreamWithFetch = async (
  conversationId: string,
  message: string,
  contextFileIds?: string[]
): Promise<ReadableStreamDefaultReader<Uint8Array>> => {
  try {
    const token = localStorage.getItem("jwtToken");

    const requestBody: any = { message };
    if (contextFileIds && contextFileIds.length > 0) {
      requestBody.contextFileIds = contextFileIds;
    }

    const response = await fetch(`${url}${BASE_PATH}/chat/${conversationId}`, {
      method: "POST",
      headers: {
        Accept: "text/event-stream",
        "Content-Type": "application/json",
        Authorization: token ? "Bearer " + token : "",
        "Cache-Control": "no-cache",
      },
      body: JSON.stringify(requestBody),
    });

    return response.body.getReader();
  } catch (error) {
    console.error("Error in createChatStreamWithFetch:", error);
    throw error;
  }
};
